import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/ui/Button';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="text-9xl font-bold text-indigo-600 mb-4">404</div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Página não encontrada</h1>
          <p className="text-gray-600">
            Desculpe, a página que você está procurando não existe ou foi movida.
          </p>
        </div>

        <div className="space-y-3">
          <Button
            variant="primary"
            onClick={() => navigate('/')}
            className="w-full"
          >
            Voltar para a página inicial
          </Button>
          <Button
            variant="secondary"
            onClick={() => navigate(-1)}
            className="w-full"
          >
            Voltar à página anterior
          </Button>
        </div>

        <div className="mt-8 text-sm text-gray-500">
          <p>Se você acredita que isso é um erro, entre em contato conosco.</p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
